import { render, staticRenderFns } from "./CategoryDashboard.vue?vue&type=template&id=0c38bab2&scoped=true"
import script from "./CategoryDashboard.vue?vue&type=script&lang=js"
export * from "./CategoryDashboard.vue?vue&type=script&lang=js"
import style0 from "./CategoryDashboard.vue?vue&type=style&index=0&id=0c38bab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c38bab2",
  null
  
)

export default component.exports